// extracted by mini-css-extract-plugin
export default {"container":"ZjFzS6JW6HUCWr2AoKlm","collapsibleContent":"rMwfr6qSVXiEA18tBO2Q"};